import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/src/client/layers/base/layouts/default.vue").then(m => m.default || m))
}